import React from 'react'
import TopBar from './TopBar'
import SidebarNew from './sidebar/SidebarNew'

const SidebarV2 = () => {
  return (
    <>
      <TopBar sx={{marginLeft: '100px'}} />
      <SidebarNew />
    </>
  )
}

export default SidebarV2
